import gql from 'graphql-tag';

export const UPLOAD_VIDEO_FROM_URL = gql`
  mutation UploadVideoFromUrl($url: String!, $title: String!, $articleGroupId: String!) {
    uploadVideoFromUrl(url: $url, title: $title, articleGroupId: $articleGroupId) {
      id
      errors
    }
  }
`;
